import "./partials/pagination";
import "./partials/cards";
import "./partials/search";
import "./partials/header";
import "./partials/modal"
